import Vue from "vue"

// Localizes ISO 8601 data (YYYY-MM-DD) to French date (DD/MM/YYYY).
function localizeDate(value) {
  if (value) {
    let parts = value.toString().split("-")
    return parts[2] + "/" + parts[1] + "/" + parts[0]
  }
}

// Localizes a number to a French integer number divided spaces.
function localizeNumber(value, round = 0) {
  if (value == null) return
  value = value.toString()

  let segments = []
  let dot = value.indexOf(".")
  let decimals = ""

  if (dot > -1) {
    decimals = value.substring(dot, value.length)
    value = value.substring(0, dot)
    if (round) {
      if (decimals.length < 3) {
        decimals += "0"
      } else {
        decimals = decimals.substring(0, 3)
      }
    }
  } else if (round > 0) {
    decimals = ".00"
  }

  while (value.length > 3) {
    segments.unshift(value.substring(value.length - 3, value.length))
    value = value.substring(0, value.length - 3)
  }
  segments.unshift(value)

  return segments.join("&nbsp;") + decimals
}

// Localizes a number to a French number (see `localizeNumber`) and a currency
// unit (€).
function localizeCurrency(value, decimals = true) {
  if ((value = localizeNumber(value, decimals ? 2 : 0))) {
    return value + "&nbsp;€"
  }
}

Vue.filter("localizeDate", localizeDate)
Vue.filter("localizeNumber", localizeNumber)
Vue.filter("localizeCurrency", localizeCurrency)
